import { create } from 'zustand'

export const useDlcFramesForm = create((set) => ({
  contentTag: null,
  after: null,
  afters: [],
  setContentTag: (contentTag) =>
    set((state) => {
      const next = contentTag || null
      if (state.contentTag === next) return state
      return {
        contentTag: next,
        after: null,
        afters: [],
      }
    }),
  goAfter: (nextAfter) =>
    set((state) => {
      if (nextAfter === null) {
        return { after: null }
      }
      const index = state.afters.findIndex((a) => a === nextAfter)
      if (index === -1) {
        return { after: nextAfter, afters: [...state.afters, nextAfter] }
      }
      return { after: nextAfter }
    }),
}))
